import './scss/vitrine.scss'
import type { DestaqueMiniaturaBlackProps } from "../../types/vitrineApp.props"
import { Device } from '../../data/device'
import { ItemOferta } from './components/ItemOferta'
import { ProdutoPrincipal } from './components/ProdutoPrincipal'
import { TitleCtn } from '../../components/TitleCtn'
import type { Produto } from '../../types/produto.props'

export function DestaqueMiniaturaBlack({
    hostImagem,
    produtos,
    vitrineMacro,
    blackfriday,
    validaTempoVitrine,
    tituloVitrine,
    exibeValoresSomenteLogado,
    precoPrincipal,
    device,
    zordHintLoading,
    vitrineButtonAddToCart,
    hoverImagensVitrine,
    hoverImagensVitrineMobile,
    utilizaFavoritosVitrine,
    width,
    height
}: Readonly<DestaqueMiniaturaBlackProps>){
    const produtosArray: Produto[] = Array.isArray(produtos) ? produtos : Object.values(produtos) as Produto[]
    const produtoDestaque = produtosArray[0]
    const isMobileDevice = [Device.MOBILE, Device.APP, Device.TABLET].includes(device)
    let produtosItens = []

    if (isMobileDevice) {
        produtosItens = produtosArray.slice(0,4)
    } else {
        produtosItens = produtosArray.slice(1,4)
    }

    return (
        <>
            {!blackfriday && <TitleCtn tituloVitrine={tituloVitrine} />}

            <div className="container">
                <div className={`macro-vitrine-1-destaque-3-miniatura-black ${vitrineMacro}`}>
                    {(produtosArray.length > 0) && (
                        <div className="box-produtos-ofertas flex space-between">
                            {!isMobileDevice && (
                                <ProdutoPrincipal
                                    hostImagem={hostImagem}
                                    produtoDestaque={produtoDestaque}
                                    precoPrincipal={precoPrincipal}
                                    exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                    blackfriday={blackfriday}
                                    utilizaFavoritosVitrine={utilizaFavoritosVitrine}
                                    device={device}
                                    validaTempoVitrine={validaTempoVitrine}
                                    zordHintLoading={zordHintLoading}
                                    vitrineButtonAddToCart={vitrineButtonAddToCart}
                                    width={width}
                                    height={height}
                                    hoverImagensVitrine={hoverImagensVitrine}
                                    hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                />
                            )}

                            <div className="produtos-itens">
                                {produtosItens.map((produto) => (
                                    <ItemOferta
                                        key={`${produto.produto_id}-${produto.derivacao_id}`}
                                        hostImagem={hostImagem}
                                        produto={produto}
                                        produtoDestaque={produtoDestaque}
                                        precoPrincipal={precoPrincipal}
                                        exibeValoresSomenteLogado={exibeValoresSomenteLogado}
                                        blackfriday={blackfriday}
                                        utilizaFavoritosVitrine={utilizaFavoritosVitrine}
                                        device={device}
                                        zordHintLoading={zordHintLoading}
                                        validaTempoVitrine={validaTempoVitrine}
                                        vitrineButtonAddToCart={vitrineButtonAddToCart}
                                        width={width}
                                        height={height}
                                        hoverImagensVitrine={hoverImagensVitrine}
                                        hoverImagensVitrineMobile={hoverImagensVitrineMobile}
                                    />
                                ))}
                            </div>
                        </div>
                    )}
                </div>
            </div>
        </>
    )
}
